const title = {
	es: {
		first: "¡Ups! ",
		last: "Página no encontrada."
	},
	en: {
		first: "Oops! ",
		last: "Page not found."
	},
	pt: {
		first: "Ops! ",
		last: "Página não encontrada."
	}
}

const content = {
	es: 'Parece que te has salido del mapa.<br/>No te preocupes, te ayudamos a volver.',
	en: 'Looks like you’ve wandered off the map.<br/>No worries, we’ll get you back on track.',
	pt: 'Parece que você saiu da rota.<br/>Sem problemas, a gente te ajuda a encontrar o caminho de novo.',
}

export { title, content };